<script>
import Vue from 'vue';

var myMixin = {
  computed: {
    error: function () {
      var _this = this;
      var error = '';

      if (this.errors == undefined)
        return '';

      this.errors.map(function(err) {
        if (err.id == _this.id)
          error = err;
      });

      if (error != '') {
        return error.msg;
      } else {
        return '';
      }
    }
  }
}

Vue.component('ajaxLoaderButton', {
  props: ['label','iconclass','onClick','value','className'],
  data: function() {
    return {
      guid: '',
      className_: ''
    };
  },
  template: '<button :id="id" :disabled=value :class="className_" type="button" v-on:click="click"><i :class="iconclass"></i>{{ label }}</button>',
  mounted: function() {
    if (this.className == undefined || this.className == '') {
      this.className_ = 'btn btn-primary';
    } else {
      this.className_ = this.className;
    }
  },
  watch: {
    value: function(newval, oldval) {
      if (newval) {
        this.className_ += ' with-preloader';
        $.fn.spin.presets.preloader = {lines:13, length:0, width:3, radius:10, scale:.75, corners:1, opacity:.25, speed:1};
        $('#'+this.guid).spin('preloader');
      } else if (!newval) {
        this.className_ = this.className_.replace(' with-preloader', '');
        $('#'+this.guid).spin(false);
      }
    }
  },
  computed: {
    id: function() {
      this.guid = this.generateGUID();
      return this.guid;
    }
  },
  methods: {
    generateGUID: function() {
        function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },
    click: function() {
      this.onClick();
    }
  }
});

Vue.component('inputbox', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','disabled','keyup','datepicker','keydownEnter','inputCheck','maxlength'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
            <input :id="id" class="form-control" v-bind:name="name"\
                             v-bind:disabled="disabled"\
														 ref="input"\
													 	 type="text"\
                             v-bind:maxlength="maxlength"\
													 	 v-bind:value="value"\
                             v-on:keyup="onKeyup"\
                             v-on:keydown.enter.prevent="onKeydownEnter"\
														 v-on:input="updateValue($event.target.value)">\
		<div v-if="error.length" class="validation-error">{{ error }}</div>\
	</div>',
  mounted: function() {
    var _this = this;
    if (this.datepicker != undefined) {
      $('#'+this.id).datepicker({
        dateFormat: "yy-mm-dd",
        onClose: function(date) {
          _this.updateValue(date);
        }
      });
    }
  },
	methods: {
    onKeydownEnter: function() {
      if (this.keydownEnter != undefined)
        this.keydownEnter();
    },
    updateValue: function (value) {
      if (this.inputCheck != undefined) {
        switch(this.inputCheck) {
          case "integer":
            value = value.replace(/[^\d]/g,'');
          break;
          case "float":
            value = value.replace(/[^0-9.]/g,'');
          break;
          case "name":
            value = value.replace(/[^a-zA-Z. öüóőúéáűíÖÜÓŐÚÉÁŰÍ0-9-,']/g,'');
          break;
          case "neptuncode":
            value = value.replace(/[^a-zA-Z0-9]/g,'').toUpperCase();
          break;
          case "phone":
            value = value.replace(/[^0-9+\/-]/g,'');
          break;
          case "orgware":
            value = value.replace(/[^A-Za-z0-9-]/g,'');
          break;
          case "personalDocumentID":
            value = value.replace(/[^A-Za-z0-9-]/g,'');
          break;
          case "cardRf":
            value = value.replace(/[^a-zA-Z0-9]/g,'').toUpperCase();
          break;
          /*case "ad_username":
            value = value.replace(/[^A-Za-z0-9-_]/g,'');
          break;*/
        }
      }

      $('#'+this.id).val(value);

      this.$emit('input', value);
    },
    onKeyup: function() {
      if (this.keyup != undefined)
        this.keyup(this.value);
    }
  }
});

Vue.component('textareabox', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','disabled','cstyle'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
            <textarea :id="id" class="form-control" v-bind:name="name"\
                             v-bind:style="cstyle"\
                             v-bind:disabled="disabled"\
														 ref="input"\
													 	 v-bind:value="value"\
														 v-on:input="updateValue($event.target.value)">\
                             </textarea>\
		<div v-if="error.length" class="validation-error">{{ error }}</div>\
	</div>',
	methods: {
    updateValue: function (value) {
      this.$emit('input', value);
    }
  }
});

Vue.component('passwordbox', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','keyup','keydownEnter'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
            <input :id="id" class="form-control" v-bind:name="name"\
														 ref="input"\
													 	 type="password"\
													 	 v-bind:value="value"\
                             v-on:keyup="onKeyup"\
                             v-on:keydown.enter.prevent="onKeydownEnter"\
														 v-on:input="updateValue($event.target.value)">\
		<div v-if="error.length" class="validation-error">{{ error }}</div>\
	</div>',
	methods: {
    onKeydownEnter: function() {
      if (this.keydownEnter != undefined)
        this.keydownEnter();
    },
    updateValue: function (value) {
      this.$emit('input', value);
    },
    onKeyup: function() {
      if (this.keyup != undefined)
        this.keyup(this.value);
    }
  }
});

Vue.component('checkbox', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
    <div class="checkbox"><input :id="id" v-bind:name="name"\
														 v-model="value.selected"\
													 	 type="checkbox"\
													 	 v-bind:value="value.value"><label :for="id">{{ label }}</label></div>\
	 	<div v-if="error.length" class="validation-error">{{ error }}</div>\
	</div>'
});

Vue.component('radio', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
    <div class="radio"><input :id="id" v-bind:name="name"\
														 v-model="value.selected"\
													 	 type="radio"\
													 	 v-bind:value="value.value"><label :for="id">{{ label }}</label></div>\
	 	<div v-if="error.length" class="validation-error">{{ error }}</div>\
	</div>'
});

Vue.component('toggle', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
            <div><input :id="id" style="display:none" v-bind:name="name"\
														 v-model="value.selected"\
													 	 type="checkbox"\
													 	 v-bind:value="value.value">\
<div class="toggle-wrapper"><div v-on:click="toggle" class="toggle" v-bind:class="{active}"><div class="toggle-slide"><div class="toggle-inner"><div class="toggle-on">Igen</div><div class="toggle-blob"></div><div class="toggle-off">Nem</div></div></div></div></div>\
</div>\
	 	<div v-if="error.length" class="validation-error">{{ error }}</div>\
	</div>',
  computed: {
    active: function() {
      return this.value.selected ? "active" : "";
    }
  },
  methods: {
    toggle: function() {
      this.value.selected = !this.value.selected;
    }
  }
});

Vue.component('checkboxes', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
		<div v-for="(v, index) in value.items">\
		  <div class="checkbox"><input :id="inputid(index)" v-bind:value="v.value"\
										v-bind:name="name"\
										v-model="value.selected"\
										type="checkbox"><label :for="inputid(index)">{{ v.label }}</label>\
      </div>\
		</div>\
		<div v-if="error.length" class="validation-error">{{ error }}</div>\
	</div>',
  methods: {
    inputid: function(index) {
      return this.name + "_" + index;
    }
  }
});

Vue.component('radios', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name'],
  template: '<div v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
		<div v-for="(v, index) in value.items">\
			<div class="radio"><input :id="inputid(index)" v-bind:index="index"\
										v-bind:value="v.value"\
										v-bind:name="name"\
										v-model="value.selected"\
										type="radio"><label :for="inputid(index)">{{ v.label }}</label>\
      </div>\
		</div>\
		<div v-if="error.length" class="validation-error">{{ error }}</div>\
	</div>',
  methods: {
    inputid: function(index) {
      return this.name + "_" + index;
    }
  }
});

Vue.component('combobox', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','change','disabled'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
			<select v-bind:disabled="disabled" v-on:change="onChange(value.selected)" class="form-control" v-bind:name="name" v-bind:id="id" v-model="value.selected">\
				<option v-for="item in value.items" v-bind:value="item.value">{{item.label}}</option>\
			</select>\
		<div v-if="error.length" class="validation-error">{{ error }}</div>\
	</div>',
  methods: {
    onChange: function(val) {
      if (this.change != undefined)
        this.change(val);
    }
  }
});

Vue.component('select2', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','multi','change','disabled'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
			<select v-bind:disabled="disabled" :multiple="multiple" class="form-control select2js" v-bind:name="name" v-bind:id="id" v-model="value.selected">\
				<option v-for="item in value.items" v-bind:value="item.value">{{item.label}}</option>\
			</select>\
    <div v-if="error.length" class="validation-error">{{ error }}</div>\
	</div>',
  mounted: function() {
    var _this = this;
    $('#'+this.id).select2({placeholder: 'Válasszon...'})
    .on("select2:select", function (e) {
      _this.value.selected = $('#'+_this.id).val();
      if (_this.change != undefined)
        _this.change(_this.value.selected);
    })
    .on("select2:unselect", function (e) {
      _this.value.selected = $('#'+_this.id).val();
      if (_this.change != undefined)
        _this.change(_this.value.selected);
    });
  },
  computed: {
    multiple: function() {
      return this.multi == "true" ? true : false;
    }
  }
});

Vue.component('select2ajax', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','multi','change','disabled','url'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
			<select v-bind:disabled="disabled" :multiple="multiple" class="form-control select2js" v-bind:name="name" v-bind:id="id" v-model="value.selected">\
				<option v-for="item in value.items" v-bind:value="item.value">{{item.label}}</option>\
			</select>\
    <div v-if="error.length" class="validation-error">{{ error }}</div>\
	</div>',
  mounted: function() {
    var _this = this;
    $('#'+this.id).select2({
      placeholder: 'Kezdjen el írni...',
      ajax: {
        url: 'api/'+this.url,
        dataType: 'json',
        delay: 250,
        method: 'POST',
        data: function (params) {
          return {
            q: params.term,
            page: params.page
          };
        },
        processResults: function (data, params) {
          return {
            results: data.items
          };
        },
        cache: true
      },
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2
    }).on("select2:select", function (e) {
      _this.value.selected = $('#'+_this.id).val();
      if (_this.change != undefined)
        _this.change(_this.value.selected);
    })
    .on("select2:unselect", function (e) {
      _this.value.selected = $('#'+_this.id).val();
      if (_this.change != undefined)
        _this.change(_this.value.selected);
    });
  },
  computed: {
    multiple: function() {
      return this.multi == "true" ? true : false;
    }
  }
});

Vue.component('pagination', {
  props: ['limit','amount','value','showcombo'],
  data: function() {
     return {
         page: parseInt(this.value),
         from: 1,
         to: 0,
         pagec: 0
     };
  },
  template: '<section>\n\
<div style="padding-bottom: 10px;">Összesen {{ amount }} találat, {{ pagec }} lapon.</div>\n\
<ul class="pagination">\n\
  <li v-if="showcombo"><select v-model="page" v-on:change="comboChange" class="form-control"><option v-for="i in comboIndex" v-bind:value="i">{{i}}</option></select></li>\n\
  <li><a v-on:click="firstClick" href="javascript:void(0)" aria-label="Első"><span aria-hidden="true"><i class="fa fa-angle-double-left"></i></span></a></li>\n\
  <li><a v-on:click="prevClick()" href="javascript:void(0)" aria-label="Előző"><span aria-hidden="true"><i class="fa fa-angle-left"></i></span></a></li>\n\
  <li v-for="i in renderLiIndex" v-bind:class="{active: i == page}"><a v-on:click="pageClick(i)" href="javascript:void(0)">{{ i }}</a></li>\n\
  <li><a v-on:click="nextClick" href="javascript:void(0)" aria-label="Következő"><span aria-hidden="true"><i class="fa fa-angle-right"></i></span></a></li>\n\
<li><a v-on:click="lastClick" href="javascript:void(0)" aria-label="Utolsó"><span aria-hidden="true"><i class="fa fa-angle-double-right"></i></span></a></li>\n\
</ul>\n\
</section>',
  mounted: function() {
    this.calcToFrom();
  },
  computed: {
    renderLiIndex: function() {
      var arr = [];
      for (var i = this.from; i <= this.to; i++) {
        arr.push(i);
      }
      return arr;
    },
    comboIndex: function() {
      var arr = [];
      for (var i = 1; i <= this.pagec; i++) {
        arr.push(i);
      }
      return arr;
    }
  },
  watch: {
    value: function(newval, oldval) {
      this.page = parseInt(newval);
      this.calcToFrom();
    },
    page: function(newval, oldval) {
      this.page = parseInt(newval);
      this.calcToFrom();
    },
    amount: function(newval, oldval) {
      this.calcToFrom();
    },
    limit: function(newval, oldval) {
      this.calcToFrom();
    },
  },
  methods: {
    calcToFrom: function() {
      var page = parseInt(this.page);
      var amount = parseInt(this.amount);
      var limit =  parseInt(this.limit);
      var from = parseInt(this.from);
      var to = parseInt(this.to);

      this.pagec = Math.ceil(amount / limit);

      if (this.pagec >= 7) {
        if (page - 3 <= 1) {
          this.from = 1;
          this.to = from + 6;

        } else if (page + 3 <= this.pagec) {
          this.from = page - 3;
          this.to = page + 3;
        } else {
          var extra = (page + 3) - this.pagec;
          this.from = (page - 3) - extra;
          this.to = this.pagec;
        }
      } else {
        this.from = 1;
        this.to = this.pagec;
      }
    },
    comboChange: function() {
      this.$emit('pageChanged', this.page);
    },
    pageClick: function(page) {
      this.page = page;
      this.$emit('pageChanged', page);
    },
    prevClick: function() {
      if (this.page > 1)
        this.page = this.page - 1;

      this.$emit('pageChanged', this.page);
    },
    nextClick: function() {
      if ((parseInt(this.page) + 1) > this.pagec) {
        this.page = this.pagec;
      } else {
        this.page = parseInt(this.page) + 1;
      }
      this.$emit('pageChanged', this.page);
    },
    lastClick: function() {
      this.page = this.pagec;
      this.$emit('pageChanged', this.page);
    },
    firstClick: function() {
      this.page = 1;
      this.$emit('pageChanged', this.page);
    }
  },
});
</script>



// WEBPACK FOOTER //
// components.vue?6953c88c